import {List, Map} from 'immutable'
import {ADICIONAR_PESSOA_CORRETOR, 
        EDITAR_INFORMACOES_CORRETOR,
        REMOVER_PESSOA_CORRETOR_STORE,
        CARREGAR_CORRETORES_STORE} from '../constants/constants'

function outterCorretores(state, action){
    switch(action.type){
        case CARREGAR_CORRETORES_STORE:
            return List(action.corretores.map(b => Map(b)))
    }
    return state
}

export default (corretoresState = List(), action)=>{

    let newState = outterCorretores(corretoresState, action);
    let {id, usuario, telefones, senha, nivel} = action;
    let tmpIndex;
    console.log(newState)

    switch(action.type){
        
        case EDITAR_INFORMACOES_CORRETOR:
            tmpIndex = newState.findIndex(x => x.get('id') == id);
            return newState.set(tmpIndex, Map({id, usuario, telefones, senha, nivel, ...newState.get(tmpIndex)}));

        case REMOVER_PESSOA_CORRETOR_STORE:
            tmpIndex = newState.findIndex(x => x.get('id') == id);
            return newState.delete(tmpIndex);

        default :
             return newState;            
    }
    
}



// WEBPACK FOOTER //
// ./src/reducers/corretores.js